import { useRef as r } from "react";
const o = (t) => {
  const e = r(t);
  return e.current = t, e;
};
export {
  o as default
};
//# sourceMappingURL=useLatest.js.map
